import hint from '#frontend/singleDataLayer/shared/hint.js';

/**
 * System show hint message
 * @param {string} originalDomain Original domain typed by user
 * @param {string} suggestedDomain Suggested domain by system
 * @param {string} code hint code
 * @param {string} type hint type
 * @returns {object}
 */
export default (originalDomain, suggestedDomain, code, type) => ({
	system: {
		hint: hint(originalDomain, suggestedDomain, code, type)
	},
	event: 'system.hint'
});
